import {
  Checkbox as BaseCheckbox,
  CheckboxPassThroughOptions,
  CheckboxProps,
} from 'primereact/checkbox';
import { FC } from 'react';
import S from './Checkbox.module.scss';

type Props = CheckboxProps;

const pt: CheckboxPassThroughOptions = {
  root: {
    className: S.root,
  },
};

export const Checkbox: FC<Props> = (props) => {
  return <BaseCheckbox pt={pt} {...props}></BaseCheckbox>;
};
